import { /* useCallback, */ useEffect, useRef, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { /* Stack, */ Typography } from '@mui/material';

// import { blue, yellow } from '@mui/material/colors';
import { LeftSidebarBlock } from '@/dmdrive/topic/components/Topic/LeftSidebar/LeftSidebar.styles';
import { /* useTopicStore*, */ useTopicViewerStore } from '@/dmdrive/topic/components/Topic/TopicStore';
// import { invalidateLimitsRange } from '@/dmdrive/topic/helpers/invalidateLimitsRange';
import { BackdropLoader } from '@/dmdrive/ui-kit/components';

// import SwitchField from '@/dmdrive/ui-kit/components/SwitchField/SwitchField';
import {
  // HistogramContainer,
  // HistogramContent,
  HistogramControls,
  HistogramGraph,
  // HistogramGraphOverlay,
  HistogramLoader,
  HistogramPanel,
  // HistogramXAxis,
  HistogramYAxis,
} from './Histogram.styles';

import { HistogramMeasurement } from './Histogram.types';
import { getHistogramMeasurements } from './Histogram.utils';
// import HistogramViewButtons from './HistogramViewButtons/HistogramViewButtons';
import LimitControls from './LimitControls/LimitControls';
import PaletteControl from './PaletteControl/PaletteControl';

function Histogram() {
  // const { isControlDisabled } = useTopicStore();
  const { viewerSettings, histogram, isHistogramCalcInProgress } = useTopicViewerStore();

  const {
    histogramScaleView,
    // histogramLowerValue,
    // histogramUpperValue,
    // histogramLowerLimit,
    // histogramUpperLimit,
    // isPaletteZeroPoint,
    // switchModelsOnHistogram: isSwitchModelsOnHistogram,
    // apply,
  } = viewerSettings;

  const contentRef = useRef<Nullable<HTMLDivElement>>(null);

  // const onSwitchModels = useCallback(() => {
  //   apply({
  //     switchModelsOnHistogram: !isSwitchModelsOnHistogram,
  //   });
  // }, [isSwitchModelsOnHistogram]);

  // const setHistogramRanges = useCallback(
  //   (range: [number, number]) => {
  //     const [lower, upper] = invalidateLimitsRange(range, isPaletteZeroPoint);

  //     apply({
  //       histogramLowerValue: lower,
  //       histogramUpperValue: upper,
  //     });
  //   },
  //   [isPaletteZeroPoint],
  // );

  // const toggleKeepPaletteZeroPoint = useCallback(() => {
  //   apply({
  //     isPaletteZeroPoint: !isPaletteZeroPoint,
  //   });

  //   const [lower, upper] = invalidateLimitsRange([histogramLowerValue, histogramUpperValue], isPaletteZeroPoint);

  //   if (lower !== histogramLowerValue) {
  //     apply({
  //       histogramLowerValue: lower,
  //     });
  //   }

  //   if (upper !== histogramUpperValue) {
  //     apply({
  //       histogramUpperValue: upper,
  //     });
  //   }
  // }, [isPaletteZeroPoint, histogramLowerValue, histogramUpperValue]);

  const [measurements, setMeasurements] = useState<Nullable<HistogramMeasurement>>(null);

  useEffect(() => {
    setMeasurements(getHistogramMeasurements(histogram, histogramScaleView, contentRef.current));

    return () => {
      setMeasurements(null);
    };
  }, [JSON.stringify(histogram), histogramScaleView]);

  // const isReady = Boolean(!isControlDisabled && measurements?.total && measurements?.maxPercent);

  return (
    <div>
      <LeftSidebarBlock isHeader>
        <Typography variant="h6">Histogram</Typography>
      </LeftSidebarBlock>

      <LeftSidebarBlock>
        <PaletteControl />

        <HistogramPanel>
          <HistogramGraph>
            <HistogramPanel>
              {(isHistogramCalcInProgress) && (
                <HistogramLoader>
                  <BackdropLoader isLoading />
                </HistogramLoader>
              )}

              {measurements?.yAxis && measurements.yAxis.length > 0 && (
                <HistogramYAxis>
                  {measurements.yAxis.map((value) => (
                    <Typography key={value} variant="caption">
                      <span>{value.toFixed(2)}</span>

                      <span>%</span>
                    </Typography>
                  ))}

                  <Typography variant="caption">0</Typography>
                </HistogramYAxis>
              )}

              {/* <HistogramContainer>
                <HistogramGraphOverlay
                  min={histogramLowerLimit}
                  max={histogramUpperLimit}
                  value={[histogramLowerValue, histogramUpperValue]}
                  onChange={setHistogramRanges}
                  disabled={!isReady}
                >
                  <HistogramContent ref={contentRef}>
                    {measurements && (
                      <svg width="100%" height="100%">
                        <g>
                          {measurements.data.map(({ top, left, width, height }, i) => (
                            <rect
                              key={i}
                              x={`${left}%`}
                              y={`${top}%`}
                              width={`${width}%`}
                              height={`${height}%`}
                              fill={blue[300]}
                            />
                          ))}
                        </g>

                        <rect x={`${50 - 0.25}%`} y="0" width="0.5%" height="100%" fill={yellow[500]} />
                      </svg>
                    )}
                  </HistogramContent>
                </HistogramGraphOverlay>

                <HistogramViewButtons />

                <HistogramXAxis>
                  <Typography variant="caption">
                    <span>{((histogramLowerLimit * -1) / 1000).toFixed(3)}</span>

                    <span>mm</span>
                  </Typography>

                  <Typography variant="caption">0.00</Typography>

                  <Typography variant="caption">
                    <span>{((histogramUpperLimit * -1) / 1000).toFixed(3)}</span>

                    <span>mm</span>
                  </Typography>
                </HistogramXAxis>
              </HistogramContainer> */}
            </HistogramPanel>
          </HistogramGraph>
        </HistogramPanel>

        <LimitControls />

        <HistogramControls>
          {/* <SwitchField
            label="Keep palette zero"
            size="small"
            checked={isPaletteZeroPoint}
            onChange={toggleKeepPaletteZeroPoint}
            disabled={isControlDisabled}
          /> */}

          {/* <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
            <Typography>Plan</Typography>

            <SwitchField
              size="small"
              checked={isSwitchModelsOnHistogram}
              onChange={onSwitchModels}
              disabled={isControlDisabled}
            />

            <Typography>Result</Typography>
          </Stack> */}
        </HistogramControls>
      </LeftSidebarBlock>
    </div>
  );
}

export default observer(Histogram);
